import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card shadow" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = {
  class: "accordion accordion-flush accordion-icon-toggle",
  id: "kt_accordion_2"
}
const _hoisted_4 = { class: "mb-5" }
const _hoisted_5 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_2"
}
const _hoisted_6 = { class: "accordion-icon" }
const _hoisted_7 = { class: "svg-icon svg-icon-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }, " Зээлийн мэдээллийн сан v2.0.0 - 17 May, 2022 ", -1)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div id=\"kt_accordion_2_item_2\" class=\"fs-6 collapse ps-10\" data-bs-parent=\"#kt_accordion_2\"><h3 class=\"fs-6 fw-bolder mb-1\">Шинчлэлт:</h3><ul class=\"py-2\"><li class=\"py-2\"> Шинэ template ашиглаж ЗМС амжилттай нэвтрүүллээ. </li><li class=\"py-2 text-success\"> Initial release. </li></ul><h3 class=\"fs-6 fw-bolder mb-1\">Өөрчлөлт:</h3><ul class=\"py-2\"><li class=\"py-2\"> Мал тооллогын checkbox-ийг loader-тэй болгов. </li></ul></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Right-2.svg" })
              ])
            ]),
            _hoisted_8
          ]),
          _hoisted_9
        ])
      ])
    ])
  ]))
}